import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Form, RequiredFieldsLabel } from "@sscs/ui";
import { RegisterUserOnSuccess } from "../../types";
import styles from "./registerMember.module.scss";
import useRegisterMemberForm from "./useRegisterMemberForm";

type RegisterMemberFormProps = {
  onSuccess: RegisterUserOnSuccess;
};

const RegisterMemberForm = ({
  onSuccess,
}: RegisterMemberFormProps): React.JSX.Element => {
  const { form, onSubmit } = useRegisterMemberForm(onSuccess);

  const { errors } = form.formState;

  return (
    <FormProvider {...form}>
      <Form.Form onSubmit={onSubmit}>
        <Form.TextField
          id="register-member__email"
          label="Email"
          name="email"
          autoComplete="email"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="register-member__first-name"
          label="First name"
          name="firstName"
          autoComplete="given-name"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="register-member__last-name"
          label="Last name"
          name="lastName"
          autoComplete="family-name"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="register-member__password"
          type="password"
          label="Password"
          name="password"
          autoComplete="new-password"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="register-member__confirm-password"
          type="password"
          label="Confirm password"
          name="confirmPassword"
          autoComplete="new-password"
          isRequired
          errors={errors}
        />
        <RequiredFieldsLabel />
        <div className={styles["create-account-button"]}>
          <Button id="save" type="submit" color="primary" isFullWidth>
            Create account
          </Button>
        </div>
      </Form.Form>
    </FormProvider>
  );
};

export default RegisterMemberForm;
